module.exports = __webpack_public_path__ + "static/media/arrow-up.1c9ca5f3.svg";